import React from "react";

interface SheetBodyProps {
  children: React.ReactNode;
  backgroundColor?: string;
  noScroll?: boolean;
}

export default function SheetBody({
  children,
  noScroll = false,
}: SheetBodyProps) {
  return (
    <div
      className={`flex-1 min-h-0 bg-[#F8F8F8] ${
        noScroll
          ? "flex flex-col overflow-hidden"
          : "overflow-y-auto [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden"
      }`}
    >
      <div
        className={`sheet-content-view-body ${noScroll ? "flex-1 min-h-0 flex flex-col overflow-hidden" : ""}`}
      >
        {children}
      </div>
    </div>
  );
}
